import * as Api from '@ViewModels';
import { ICampaignAudience } from '../hooks/useCampaignAudiences';

interface IComposeCampaignAudienceEmailFieldsArgs {
	audience: ICampaignAudience;
	mainContactsFilterRequest?: Api.IEmailMessageContactsFilterRequest;
	/**
	 * Applies the account's default bulk-send tag excludes (and send-from private-contact rules) to a
	 * raw contacts filter. Injected as a closure over the shared email composer so this stays pure.
	 */
	defaultExcludesApplier: (filter: Api.IContactsFilterRequest) => Api.IContactsFilterRequest;
}

export function composeCampaignAudienceEmailFields({
	audience,
	mainContactsFilterRequest,
	defaultExcludesApplier,
}: IComposeCampaignAudienceEmailFieldsArgs): {
	contactsFilterRequest: Api.IEmailMessageContactsFilterRequest;
	groupByHousehold: boolean;
} {
	const ownershipFilter = audience.ownershipFilter ?? mainContactsFilterRequest?.ownershipFilter;

	return {
		contactsFilterRequest: {
			contactFilterRequest: defaultExcludesApplier({ criteria: audience.criteria, op: Api.FilterOperator.Or }),
			groupByDuplicate: true,
			groupByHousehold: audience.groupByHousehold,
			ownershipFilter,
		},
		groupByHousehold: audience.groupByHousehold,
	};
}
